import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import { WatchFilters } from '../../watch/interfaces/interfaces';

export type TabNavTriggerType =
  'refreshAppointments'
  | 'refreshOrganizations'
  | 'refreshWorks'
  | 'refreshVehicle'
  | 'refreshServices'
  | 'refreshWithOutTeam'
  | 'resetAll'
  | 'refreshLabmed'
  | 'refreshWatchs'
  | 'refreshFieldSale'

export interface TabNavTriggerPayload {
  type: TabNavTriggerType;
  filter?: any;
}

@Injectable({providedIn: 'root'})
export class TriggerService {
  private readonly refreshWatchsSubject = new Subject<WatchFilters>();

  refreshWatchs$ = this.refreshWatchsSubject.asObservable();

  private readonly _triggerTabNav = new Subject<TabNavTriggerPayload>();
  triggerTabNav$ = this._triggerTabNav.asObservable();

  triggerTabNavAction(type: TabNavTriggerType, filter?: any) {
    this._triggerTabNav.next({type, filter});
  }

    triggerRefreshWatchs(filter: WatchFilters) {
    this.refreshWatchsSubject.next(filter);
  }
}
